import React from 'react'
import {Link} from 'react-router-dom';
import clsx from 'clsx'
import { fade, makeStyles, useTheme } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import Drawer from '@material-ui/core/Drawer'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import Logo from '../../Assets/--WhiteBluePNG-TM.png'
import SearchIcon from '@material-ui/icons/Search'
import SignOutIcon from '@material-ui/icons/ExitToApp'
import './SideDrawer.css'
import ListItems from './DashboardSidebarItems'
import {Button} from '@material-ui/core'
import { connect } from 'react-redux'
import { unauthenticate } from '../../Actions/authActions'
import StackVertical from '../Universal/StackVertical'
import {removeAuthToken} from "../../Helpers";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: { // flexbox container
    flexGrow: 1,
    height: '100vh'
  },
  appBar: {

    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#09D712 !important'
    }
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },
  toolbar: {
    height: '80px'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: '100%', // actual search input field
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    // width: '100%', //actual text input
    fontSize: '11px',
    [theme.breakpoints.up('sm')]: { // screen width is bigger than sm
      width: 200
    }
  },
  logo: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    },
    width: 200,
    height: 'auto'
  }
}))

function SideDrawer (props) {
  const classes = useStyles()
  const theme = useTheme()
  const [open, setOpen, signOut] = React.useState(false)

  const handleDrawerOpen = () => {
    setOpen(true)
  };

  const handleDrawerClose = (test) => {
    console.log(`handledrawer close triggered ${test}`);
    setOpen(false)
  };
  const onSignOut = () => {
    removeAuthToken();
    window.location.href = '/';
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        className={classes.drawer}
        variant='persistent'
        anchor='left'
        open={open}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItems onHandleDrawerClose={handleDrawerClose} />
        </List>
      </Drawer>
      <div
        position='static'
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open
        })}
        style={{ paddingBottom: 100 }}
      >
        <AppBar
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open
          })}
        >
          <Toolbar className={classes.toolbar}>
            <div className='container-left'>
              <IconButton
                color='inherit'
                aria-label='open drawer'
                onClick={handleDrawerOpen}
                edge='start'
                className={clsx(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Link to='/'><img alt='FocusLoop' src={Logo} className={classes.logo} /></Link>
            </div>
            <div className='container-right'>
              <Button
                href='/advertiser/campaigns/create'
                variant="outlined"
                color="inherit"
                style={{
                  backgroundColor: '#03A9F4',
                  border: '3px solid white',
                  color: 'white',
                  marginRight: '16px',
                  padding: '8px 16px',
                }}
                className={classes.menuButton}
              >
                Create&nbsp;Campaign
              </Button>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder='search campaigns & customer lists'
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  fullWidth
                  inputProps={{ 'aria-label': 'search' }}
                />
              </div>
            </div>
            <div
              id='sign-out-div'
              onClick={onSignOut}
            >
              <SignOutIcon id='sign-out-icon' style={{ marginRight: 8 }} /><span>SIGN OUT</span>
            </div>
          </Toolbar>
        </AppBar>
        {props.children}
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    campaigns: state.r_campaign.campaigns
  }
}
const mapDispatchToProps = { unauthenticate };
export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer)
